import { cn } from "@/lib/utils"

import type { StoneTexture, StoneToneSkin } from "./tones"

type StoneFillProps = {
  skin: StoneToneSkin
  className?: string
}

// Plate under the border. Inset by 1px so the ring (>= 1.6px thick) always covers its edge: a box
// background snaps to whole device pixels while the SVG ring is drawn at its exact fractional
// position, so at a fractional offset a flush fill would leak a dark hairline outside the stroke.
// Inner shadow is the Figma BG effect (Y 8, blur 16.3, black 100%).
export function StoneFill({ skin, className }: StoneFillProps) {
  return (
    <span
      className={cn(
        "absolute inset-px shadow-[inset_0_8px_16.3px_0_--theme(--color-black-1000)]",
        skin.fill,
        className ?? "rounded-[calc(var(--stone-radius)-1px)]",
      )}
    />
  )
}

type StoneTextureLayerProps = {
  texture: StoneTexture
  className?: string
}

// Figma "Header bg texture": a sibling above BG (so it grains the stroke as well as the fill),
// blend mode Screen, tiled at 1x CSS size (asset is 2x) and centred — not scaled to cover.
export function StoneTextureLayer({
  texture,
  className
}: StoneTextureLayerProps) {
  return (
    <span
      className={cn(
        "absolute inset-0 bg-center bg-repeat mix-blend-screen",
        texture.sizeClass,
        texture.opacityClass,
        className
      )}
      style={{
        backgroundImage: `url("${texture.src}")`,
        backgroundSize: `${texture.width / texture.pixelRatio}px ${texture.height / texture.pixelRatio}px`
      }}
    />
  )
}
